'use client'

import get from 'lodash.get'

import { useSuspenseQuery } from '@apollo/client'

import { DEFAULT_REGION, DEFAULT_SECTION_SLUG } from '~/utils/consts'
import { notEmpty } from '~/utils/function'

import { CollectionCategoryEnum, HomepageQueryDocument, HomepageQueryQuery, HomepageQueryQueryVariables } from '~/app/generated/graphql'

import { CollectionSection } from '../CollectionSection'
import styles from '../CollectionSection/CollectionSection.module.css'
import { useLocation } from '../LocationMenu/LocationMenuUtils'
import cardStyles from '../ReservationOfferCard/ReservationOfferCard.module.css'

export interface LocationCollectionSectionProps {
  redirectUrl?: string
  festivalSlug?: string
  buttonText: string /* texts are from props cuz client-side translations don't work, */
  title: string /* so we getting them from server-side page */
  collectionTheme?: typeof styles
  feCode?: string
  festivalEditionId?: string
  selectLabel?: string
  cardTheme?: typeof cardStyles
}

export const LocationCollectionSectionView = ({
  redirectUrl,
  festivalSlug,
  buttonText,
  title,
  collectionTheme,
  feCode,
  festivalEditionId,
  selectLabel,
  cardTheme,
}: LocationCollectionSectionProps) => {
  const { selectedRegion } = useLocation()

  const { data: collectionData } = useSuspenseQuery<HomepageQueryQuery, HomepageQueryQueryVariables>(HomepageQueryDocument, {
    variables: {
      region_id: selectedRegion?.id || DEFAULT_REGION.id,
      section_slug: DEFAULT_SECTION_SLUG,
      ...(feCode && { category: CollectionCategoryEnum.Festivaleditionrestaurant, festival_edition_code: feCode }),
    },
  })

  const collectionsEdges = get(collectionData, 'collections.edges', [])
  const collections = collectionsEdges.map(edge => edge?.node).filter(notEmpty)

  return collections && collections.length > 0
    ? collections.map(collection => (
        <CollectionSection
          key={collection.id}
          title={title}
          collection={collection}
          buttonText={buttonText}
          theme={collectionTheme}
          customHref={redirectUrl}
          listingRedirect={festivalSlug}
          feCode={feCode}
          festivalEditionId={festivalEditionId}
          selectLabel={selectLabel}
          cardTheme={cardTheme}
          showLocationMenu
        />
      ))
    : null
}
